/**
 * @file
 * Product info scripts.
 * Changes tabs to accordion on small screen.
 */

const $responsiveTabs = $('.product-tabs .responsive-tabs', context);
const $productPage = $('.cpl-product-page', context);

$responsiveTabs.once('tab-to-accordion').each(function() {
  const $this = $(this);
  const $togglType = $this.find('.toggleType');
  const $tabWrap = $this.find('.tab-wrap');

  const accordionOnly =
    $productPage.hasClass('cpl-product-page-style-3') ||
    $productPage.hasClass('cpl-product-page-style-4');

  const transformTabs = () => {
    if ($(window).width() < 640) {
      makeAccordion();
    } else {
      makeVerticalTabs();
    }
  };

  function makeAccordion() {
    if ($this.hasClass('tabs-content')) {
      $tabWrap.css('display', 'none');
      $this.removeClass('tabs-content');
      $this.addClass('accordion');
      $togglType.addClass('accordion-item');
      $tabWrap.addClass('accordion-content');
      $tabWrap.removeClass('tabs-panel');
      $this.attr('data-accordion');
      $this
        .find('.toggleType.is-active')
        .children('.tab-wrap')
        .css('display', 'block');

      $this.find('.toggleType > .accordion-title').on('click', function(e) {
        e.preventDefault();
        $(this)
          .children('tab-wrap')
          .css('display', 'none');
        $this.find('.toggleType.is-active').removeClass('is-active');
        $(this)
          .parent()
          .addClass('is-active');
        $(this)
          .next('.accordion-content')
          .slideToggle();
        $this.find('.toggleType.is-active a').attr('aria-selected', 'true');
      });
    }
  }

  function makeVerticalTabs() {
    if ($this.hasClass('accordion')) {
      $this.removeAttr('data-accordion');
      $this.removeClass('accordion');
      $tabWrap.removeClass('accordion-content');
      $tabWrap.addClass('tabs-panel');
      $togglType.removeClass('accordion-item');
      $this.addClass('tabs-content');
      $tabWrap.css('display', '');
    }
  }

  if (!accordionOnly) {
    transformTabs();
    $(window).resize(() => {
      setTimeout(() => {
        transformTabs();
      }, 250);
    });
  } else {
    makeAccordion();
  }
});
